<template>
  <div id="settings-timesheet">
    <PageTitle :title="$t('timesheet.settings_title')" :subtitle="$t('timesheet.settings_subtitle')"/>
    <PageContainer>
      <div class="group">
        <label>{{$t('timesheet.pay_period_duration')}}</label>
        <select v-model="data.period">
          <option :value="null" disabled hidden>{{$t('choose')}}...</option>
          <option v-for="p of periods" :value="p.id" :key="`p_${p.id}`">{{$to(p.description)}}</option>
        </select>
      </div>
      <div class="group" v-if="askingForRefStart">
        <label>
          {{$t('timesheet.pay_period_ref_date')}}
          <span><Tooltip :text="$t('timesheet.pay_period_ref_date_tooltip')"/></span>
        </label>
        <datetime
            type="date"
            value-zone="local"
            v-model="refDateProxy"
            input-style="width: 100%"
        />
      </div>
    </PageContainer>
    <PageFooter :mainAction="{action: save, text: $t('save')}" />
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle";
import PageContainer from "@/components/PageContainer";
import PageFooter from "@/components/PageFooter";
import {mapActions} from "vuex";
import {luxonDateComputedProperty} from "@/vueUtils";

export default {
  name: "SettingsTimesheet",
  components: {PageTitle, PageContainer, PageFooter},

  data() {
    return {
      periods: [
        {id: '1week', description: {fr: 'Une semaine', en: 'One week'}},
        {id: '2week', description: {fr: 'Deux semaines', en: 'Two weeks'}},
        {id: '3week', description: {fr: 'Trois semaines', en: 'Three weeks'}},
      ],
      data: {
        refStart: null,
        period: '1week'
      }
    }
  },

  computed: {
    refDateProxy: luxonDateComputedProperty(['data', 'refStart']),
    askingForRefStart() {
      return ['1week', '2week', '3week'].includes(this.data.period);
    },
    branchId() {
      return this.$route.query.branch;
    },
    companyId() {
      return this.$route.query.company;
    },
  },

  watch: {
    companyId: {
      immediate: true,
      async handler(companyId) {
        showSpinner();
        let branchId = this.branchId;
        let response = await this.getCompany({branchId, companyId});
        hideSpinner();
        if (response && response.settings) {
          Object.assign(this.data, response.settings.timesheet || {});
        }
      }
    }
  },

  async mounted() {
    this.$store.state.pageTitleTranslationKey = "timesheet.settings_title";
    this.$store.state.pageIcon = "/icon/time.svg";
  },

  methods: {
    ...mapActions(["getCompany", "saveCompany"]),

    async save() {
      let companyId = 1;
      let branchId = 1;
      let data = {
        settings: {
          timesheet: this.data
        }
      };
      showSpinner();
      let response = await this.saveCompany({branchId, companyId, data});
      hideSpinner();
      if (response) {
        toast(this.$t('timesheet.settings_save_success'), "success", this.$t("success"));
      } else {
        toast(this.$t('timesheet.settings_save_error'), "error", this.$t("error.title"));
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>